export default "__VITE_ASSET__7464d046__"